import axios from "axios";
import { metadataUrl } from "config";
import { FancyBearMetadata } from "types";

export const fetchMetadata = async (
  tokenId: number,
  cacheId?: string | null
): Promise<FancyBearMetadata> => {
  const res = await axios.get<FancyBearMetadata>(`${tokenId}`, {
    baseURL: metadataUrl,
    params: { cacheId },
  });

  return res.data;
};
